export default __webpack_public_path__ + "static/10562-43195e64481c77275c8b7840f2cd95c8.jpg";